export default __webpack_public_path__ + "static/media/genshin.034015c6.png";